import React, { useEffect } from "react";
import { useLocation, Navigate, Outlet, useParams } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import jwt_decode from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { setLogout } from '../state/GlobalState';

const RequireAuth = () => {
    const { auth } = useAuth();
    const location = useLocation();
    const { client } = useParams();
    const dispatch = useDispatch();
   
    // useEffect(() => {
    //     if (!auth || !auth.token || !auth.email || !auth.name ) {
    //         dispatch(setLogout());
    //     }
    // }, [auth, dispatch]);

    

    if (!auth || !auth.token
        // || payloadToken.sub!=="Info@superadmin" 
        // || !auth.user
        || !auth.name
    ) {
        localStorage.removeItem('auth');
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    const payloadToken = jwt_decode(auth.token);
    const isTokenExpired = Date.now() >= payloadToken.exp * 1000;

    if (!isTokenExpired) {
        return <Outlet />;
    } else {
        dispatch(setLogout());
        localStorage.removeItem('auth');
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
};

export default RequireAuth;
